import React, { Component } from "react";
import { Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import "./login.scss"

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    	usuario: '',
    	pass: '',
    }
  }

  componentDidMount() {
  }

  login = (e) => {
  	const { usuario, pass } = this.state

  	if (pass === '' || usuario === '') {
  		alert('Por favor ingresa un usuario y contraseña.')
  		return false
  	}

  	fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=login", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...this.state}),
    })
    .then(respuesta => respuesta.json())
    .then((resultado) => {
    	if ((resultado) && resultado.auth) {
    		//Si se logra exitosamente reiniciamos la app para volver a validar.
    		if(resultado.status === 1) {
	     		localStorage.setItem('nutrisadett_app_s', JSON.stringify(resultado));
	     		this.props.initsetState({ viewApp: '__redirector', })
	     		this.props.history.push('/')
	     		window.location.reload()
    		} else {
    			alert('Tu cuenta se encuentra suspendida. Contacta a tu administrador.')
    		}
    	} else {
    		alert('Credenciales incorrectas.')
    	}
    })

  }

  render() {
  	return (
      <Container className="initialPage__wrapper loginPage__container" >
        <Row className={'loginPage__formSub'}>
          <div className="col-md-12">
          	<h3 style={{ textAlign: 'center', }}>Iniciar sesión en POS Nutrisadett.</h3>
          	<form className="my-4 loginPage__form">
			        <div className="row">
			          <div className="form-group col-md-12 ">
			            <input type="text" className="form-control form-control-lg" placeholder="Ingresa tu usuario" value={this.state.usuario} onChange={(event) => this.setState({usuario: event.target.value})} />
			          </div>
			          <div className="form-group col-md-12 ">
			            <input type="password" className="form-control form-control-lg" placeholder="Ingresa tu contraseña" value={this.state.pass} onChange={(event) => this.setState({pass: event.target.value})} />
			          </div>
			        </div>

			        <div className="row">
			          <div className="form-group col-md-12 ">
			            <input onClick={this.login} type="button" className="btn btn-lg btn-info btn-block" value="INICIAR SESIÓN" />
			          </div>
			        </div>
			      </form>
          </div>
      	</Row>
      </Container>
  	);

  }
};

export default withRouter(LoginPage)